import i18n from "@/plugins/i18n";
import { filterCapitalize } from "@/filters/capitalize";

export enum EMAIL_ADDRESS_TYPE {
  To = 1,
  From = 2,
  CC = 3,
  Bcc = 4,
}

export const EMAIL_ADDRESS_TO_SEND_INPUT = [
  { value: EMAIL_ADDRESS_TYPE.To, text: filterCapitalize(i18n.t("to")) },
  { value: EMAIL_ADDRESS_TYPE.CC, text: filterCapitalize(i18n.t("copy")) },
  { value: EMAIL_ADDRESS_TYPE.Bcc, text: filterCapitalize(i18n.t("bcc")) },
];
